import { useTranslation } from 'react-i18next';
import { UI_LANGS, UiLang, applyDir } from '../i18n';

/** UI language — distinct from the audio-track language on the watch page. */
export function LangSwitcher() {
  const { i18n } = useTranslation();
  const current = (i18n.language as UiLang) in UI_LANGS ? (i18n.language as UiLang) : 'EN';

  return (
    <select
      aria-label="Language"
      value={current}
      onChange={(e) => {
        const lang = e.target.value as UiLang;
        void i18n.changeLanguage(lang);
        localStorage.setItem('uiLang', lang);
        applyDir(lang);
      }}
      className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm text-slate-700"
    >
      {(Object.keys(UI_LANGS) as UiLang[]).map((code) => (
        <option key={code} value={code}>
          {UI_LANGS[code].label}
        </option>
      ))}
    </select>
  );
}
